(() => {
  const latinText = /[A-Za-z]/;
  const arabicText = /[\u0600-\u06ff]/;

  document
    .querySelectorAll("body.template-policy .enso-policy")
    .forEach((policy) => {
      const languageBlocks = Array.from(policy.children).filter(
        (child) => child instanceof HTMLElement && child.tagName === "DIV"
      );

      if (languageBlocks.length !== 2) return;

      const [english, arabic] = languageBlocks;
      const englishContent = english.textContent || "";
      const arabicContent = arabic.textContent || "";

      if (!latinText.test(englishContent) || !arabicText.test(arabicContent)) {
        return;
      }

      english.setAttribute("lang", "en");
      english.setAttribute("dir", "ltr");
      arabic.setAttribute("lang", "ar");
      arabic.setAttribute("dir", "rtl");
      policy.setAttribute("data-enso-legal-semantics", "ready");
    });
})();
